// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"HL-z","upvoteIcon":"IL-z","downvoteIcon":"JL-z","feedbackIcon":"KL-z"};